export var PermissionEntity;
(function (PermissionEntity) {
    PermissionEntity[PermissionEntity["Branch"] = 1] = "Branch";
    PermissionEntity[PermissionEntity["Department"] = 2] = "Department";
    PermissionEntity[PermissionEntity["Role"] = 3] = "Role";
    PermissionEntity[PermissionEntity["User"] = 4] = "User";
})(PermissionEntity || (PermissionEntity = {}));
